import { ActionTypes } from '../types/api';
export const fetchStart = () => ({
    type: ActionTypes.FetchStart,
});
export const fetchSuccess = (response, fromCache) => ({
    type: ActionTypes.FetchSuccess,
    payload: {
        response,
        fromCache,
    },
});
export const fetchFailure = (error) => ({
    type: ActionTypes.FetchFailure,
    payload: {
        error,
    },
});
export const resetState = () => ({
    type: ActionTypes.ResetState,
});
